//? Lender apr
export const MIN_APR_VALUE = 9
export const MAX_APR_VALUE = 104

//? Borrower apr
export const MIN_BORROWER_APR_VALUE = 16
export const MAX_BORROWER_APR_VALUE = 110
